module.exports = __webpack_public_path__ + "static/ellen-degeneres-a98959168a0a6f8bd65aabc5c081a9c4.jpg";